// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { CompareNamesResponse } from '@coa/app/shared/select-items-shared/models/compare-stores.response';
import { SelectableFeature } from '@coa/app/shared/select-items-shared/models/selectable-feature';

export const namesRequested = createAction('[COMPARE FOOTER] Names Requested', props<{
  clientId: string,
  selectableFeature: SelectableFeature
}>());
export const namesRequestSuccess = createAction('[COMPARE FOOTER] Names Request Success', props<{
  compareNamesResponse: CompareNamesResponse
}>());
export const namesRequestError = createAction('[COMPARE FOOTER] Names Request Error');
